import { render, staticRenderFns } from "./LanguageCodeSelectInputWidget.vue?vue&type=template&id=57831a5d&scoped=true"
import script from "./LanguageCodeSelectInputWidget.vue?vue&type=script&lang=js"
export * from "./LanguageCodeSelectInputWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57831a5d",
  null
  
)

export default component.exports